<template>
    <div>
        <q-modal v-model="show_task" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" @hide="hideTaskModal()" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="hideTaskModal()" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('task') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row gutter-sm">
                        <div class="col-12">
                            <q-input v-model="task_data.branch_name" :float-label="$t('branch')" autocomplete="new-password" :error="$v.task_data.branch_name.$error" @input="$v.task_data.branch_name.$touch" @clear="clearBranch" clearable :disabled="disableStep">
                                <q-autocomplete
                                    @search="getBranch"
                                    :min-characters="3"
                                    @selected="selectBranch"
                                    :value-field="v => `${ v.name }`"
                                    separator
                                />
                            </q-input>
                        </div>

                        <div class="col-12">
                            <q-input v-model="task_data.branch_address" :float-label="$t('address')" :error="$v.task_data.branch_address.$error" @input="$v.task_data.branch_address.$touch" disable />
                        </div>

                        <div class="col-xs-12 col-sm-6">
                            <q-input v-model="task_data.branch_lat" :float-label="$t('latitude')" :error="$v.task_data.branch_lat.$error" @input="$v.task_data.branch_lat.$touch" disable />
                        </div>

                        <div class="col-xs-12 col-sm-6">
                            <q-input v-model="task_data.branch_long" :float-label="$t('longitude')" :error="$v.task_data.branch_long.$error" @input="$v.task_data.branch_long.$touch" disable />
                        </div>

                        <div class="col-xs-12 col-sm-12">
                            <q-select v-model="task_data.collection" :options="collections" :float-label="$t('questionary')" :error="$v.task_data.collection.$error" @input="$v.task_data.collection.$touch" :disable="disableStep" />
                        </div>

                        <div class="col-xs-12 col-sm-6">
                            <q-datetime v-model="start_time" type="time" :float-label="$t('start_time')" format="HH:mm:ss" :disabled="disableStep" />
                        </div>

                        <div class="col-xs-12 col-sm-6">
                            <q-datetime v-model="end_time" type="time" :float-label="$t('end_time')" format="HH:mm:ss" :disabled="disableStep" />
                        </div>

                        <div class="col-12">
                            <q-input type="textarea" v-model="observation_request" :float-label="$t('observation')" :disabled="disableStep" />
                        </div>
                    </div>

                    <div class="row gutter-sm justify-end q-mt-sm">
                        <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                            <q-btn color="tertiary" class="full-width" :label="$t('cancel')" icon="far fa-ban" @click="hideTaskModal()" />
                        </div>

                        <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                            <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveTask()" :disabled="disableStep" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>

        <q-modal v-model="show_address" no-backdrop-dismiss no-esc-dismiss :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_address = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('confirm_address') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row gutter-sm">
                        <div class="col-xs-12 col-sm-12">
                            <q-alert color="info" icon="fal fa-info">
                                {{ $t('use_the_address_field_to_search_for_the_correct_address_if_the_complete_address_button_doesnt_work_properly') }}
                            </q-alert>
                        </div>

                        <div class="col-xs-12 col-sm-12">
                            <q-input v-model="address.address" :float-label="$t('address')" autocomplete="new-password" :error="$v.address.address.$error" @input="$v.address.address.$touch">
                                <q-autocomplete
                                    @search="getAddress"
                                    :min-characters="3"
                                    @selected="selectedAddress"
                                    separator
                                />
                            </q-input>
                        </div>

                        <div class="col-xs-12 col-sm-6">
                            <q-input v-model="address.lat" :error="$v.address.lat.$error" @input="$v.address.lat.$touch" :float-label="$t('latitude')" />
                        </div>

                        <div class="col-xs-12 col-sm-6">
                            <q-input v-model="address.long" :error="$v.address.long.$error" @input="$v.address.long.$touch" :float-label="$t('longitude')" />
                        </div>

                        <div class="col-xs-12 col-sm-4">
                            <q-input v-model="address.number" :float-label="$t('number')" ref="number" />
                        </div>

                        <div class="col-xs-12 col-sm-4">
                            <q-input v-model="address.complement" :float-label="$t('complement')" />
                        </div>

                        <div class="col-xs-12 col-sm-4">
                            <q-input v-model="address.neighborhood" :float-label="$t('neighborhood')" />
                        </div>

                        <div class="col-xs-12 col-sm-4">
                            <q-input v-model="address.postal_code" :float-label="$t('postal_code')" />
                        </div>

                        <div class="col-xs-12 col-sm-4">
                            <q-input v-model="address.city" :float-label="$t('city')" :error="$v.address.city.$error" @input="$v.address.city.$touch" />
                        </div>

                        <div class="col-xs-12 col-sm-4">
                            <q-input v-model="address.state"   :float-label="$t('state')" :error="$v.address.state.$error" @input="$v.address.state.$touch" />
                        </div>
                    </div>

                    <div class="row gutter-sm justify-end q-mt-sm">
                        <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                            <q-btn color="tertiary" class="full-width" :label="$t('cancel')" icon="far fa-chevron-left" @click="show_address = false" />
                        </div>

                        <div class="col-xs-12 col-sm-3">
                            <q-btn color="positive" class="full-width" :label="$t('complete_address')" icon="far fa-check" @click="completeAddress()" />
                        </div>

                        <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                            <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveAddress()" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>

        <q-modal v-model="show_address_list" no-backdrop-dismiss no-esc-dismiss :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_address = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('address_list') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row gutter-sm">
                        <div class="col-12">
                            <q-alert color="info" icon="fal fa-info">
                                {{ $t('select_one_address_from_the_list') }}
                            </q-alert>
                        </div>

                        <div class="col-12">
                            <q-option-group
                                color="secondary"
                                type="radio"
                                v-model="selected_address"
                                :options="address_list"
                                no-parent-field
                            />
                        </div>
                    </div>

                    <div class="row gutter-sm justify-end q-mt-sm">
                        <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                            <q-btn color="tertiary" class="full-width" :label="$t('cancel')" icon="far fa-chevron-left" @click="show_address_list = false" />
                        </div>

                        <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                            <q-btn color="secondary" class="full-width" :label="$t('select')" icon="far fa-check" @click="selectAddress()" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, requiredIf, minLength } from 'vuelidate/lib/validators'
import { date } from 'quasar'
const { adjustDate, formatDate } = date
import { debounce } from 'quasar'
import { OpenStreetMapProvider } from 'leaflet-geosearch'
const provider = new OpenStreetMapProvider({
    params: {
        addressdetails: '1'
    }
})

export default {
    props: ['show_task', 'task', 'collections'],

    data() {
        return {
            task_data: {
                branch_name: null,
                collection: '',
                branch_lat: '',
                branch_long: '',
            },
            company: '',
            branch: '',
            branch_address: '',
            branch_company: '',
            branch_document: '',
            id: '',
            status: '',
            start_time: null,
            end_time: null,
            observation_request: '',
            show_address: false,
            address: {
                address: '',
                number: '',
                complement: '',
                neighborhood: '',
                postal_code: '',
                lat: '',
                long: '',
                city: '',
                state: '',
                country: ''
            },
            address_list: [],
            selected_address: null,
            show_address_list: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },

        disableStep() {
            if (this.status === 1 || !this.status) return false
            else return true
        },

        addressRequired() {
            if (this.address.address || this.address.city || this.address.state) return true
            else return false
        },
    },

    methods: {
        saveTask() {
            this.$v.$touch()

            if (!this.$v.task_data.$error) {
                this.$q.loading.show()

                let fd = new FormData()
                fd.append('branch', this.branch)
                fd.append('collection', this.task_data.collection)
                if (this.observation_request) fd.append('observation_request', this.observation_request)
                fd.append('start_time', this.start_time ? date.formatDate(this.start_time, 'HH:mm:ss') : '')
                fd.append('end_time', this.end_time ? date.formatDate(this.end_time, 'HH:mm:ss') : '')

                if (this.id != 0) {
                    this.$axios.put(`/admin_tasks/tasks/${this.$route.params.id}/task_steps/${this.id}/`, fd, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('task_save_success'),
                            type: 'positive',
                            icon: 'fal fa-save'
                        })

                        this.hideTaskModal()
                    })
                    .catch(e => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('task_save_error'),
                            type: 'negative',
                            icon: 'fal fa-ban'
                        })

                        console.log(e)
                    })
                }
                else {
                    this.$axios.post(`/admin_tasks/tasks/${this.$route.params.id}/task_steps/`, fd, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('task_save_success'),
                            type: 'positive',
                            icon: 'fal fa-save'
                        })

                        this.hideTaskModal()
                    })
                    .catch(e => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('task_save_error'),
                            type: 'negative',
                            icon: 'fal fa-ban'
                        })

                        console.log(e)
                    })
                }
            }
            else if ((this.$v.task_data.branch_lat.$error || this.$v.task_data.branch_long.$error) && !this.$v.task_data.branch_name.$error) {
                this.show_address = true
            }
        },

        saveAddress() {
            this.$v.address.$touch()

            if (!this.$v.address.$error) {
                this.$q.loading.show()

                let address = {
                    address: this.address.address,
                    number: this.address.number,
                    complement: this.address.complement,
                    postal_code: this.address.postal_code,
                    city: this.address.city,
                    state: this.address.state,
                    neighborhood: this.address.neighborhood,
                    lat: this.address.lat,
                    long: this.address.long,
                    country: this.address.country
                }

                this.$axios.post(`/admin_companies/branches/${this.branch}/update_branch_address/`, address, this.getHeader)
                .then(response => {
                    let add = response.data.address

                    this.task_data.branch_lat = add.lat
                    this.task_data.branch_long = add.long
                    this.task_data.branch_address = `${add.address} ${add.number} - ${add.city}`

                    this.address.address = add.address
                    this.address.city = add.city
                    this.address.complement = add.complement
                    this.address.lat = add.lat
                    this.address.long = add.long
                    this.address.neighborhood = add.neighborhood
                    this.address.number = add.number
                    this.address.postal_code = add.postal_code
                    this.address.state = add.state
                    this.address.country = add.country

                    this.show_address = false
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.$q.loading.hide()
                })
            }
        },

        getBranch(terms, done) {
            this.$axios.get(`/admin_companies/branches/get_branches/?search=${terms}`, this.getHeader)
            .then(response => {
                let branches = []

                response.data.forEach(element => {
                    branches.push({
                        value: element.id,
                        label: `${element.name}`,
                        address: element.address,
                        branch_type: element.branch_type,
                        branch_type_label: element.branch_type_label,
                        client: element.client,
                        company: element.company,
                        created_date: element.created_date,
                        document: element.document,
                        fantasy: element.fantasy,
                        id: element.id,
                        name: element.name,
                        regional: element.regional,
                        status: element.status,
                        updated_date: element.updated_date
                    })
                })

                done(branches)
            })
            .catch(e => {
                done([])
                console.log(e)
            })
        },

        selectBranch(item, keyboard) {
            this.company = item.company
            this.branch = item.id
            this.branch_company = item.company
            this.branch_document = item.document
            this.task_data.branch_name = item.name

            if (item && item.address) {
                this.task_data.branch_lat = item.address.lat
                this.task_data.branch_long = item.address.long
                this.task_data.branch_address = `${item.address.address} ${item.address.number} - ${item.address.city}`

                this.address.address = item.address.address
                this.address.city = item.address.city
                this.address.complement = item.address.complement
                this.address.lat = item.address.lat
                this.address.long = item.address.long
                this.address.neighborhood = item.address.neighborhood
                this.address.number = item.address.number
                this.address.postal_code = item.address.postal_code
                this.address.state = item.address.state
                this.address.country = item.address.country
            }

            if ((!this.task_data.branch_lat || !this.task_data.branch_long) && !keyboard) {
                this.show_address = true
            }
        },

        clearBranch() {
            this.branch = ''
            this.branch_address = ''
            this.branch_company = ''
            this.branch_document = ''
            this.task_data.branch_lat = ''
            this.task_data.branch_long = ''
            this.task_data.branch_name = null
        },

        hideTaskModal() {
            this.branch = ''
            this.branch_address = ''
            this.branch_company = ''
            this.branch_document = ''
            this.task_data.branch_lat = ''
            this.task_data.branch_long = ''
            this.task_data.branch_name = null
            this.task_data.collection = ''
            this.id = ''
            this.status = ''
            this.observation_request = ''
            this.start_time =  null
            this.end_time =  null

            this.$v.$reset()
            this.$emit('hide_task', '')
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        getAddress(terms, done) {
            provider.search({ query: terms })
            .then((result) => {
                done(result)
            })
        },

        selectedAddress(item) {
            this.$nextTick(() => this.address.address = item.raw.address.road)

            this.address.postal_code = item.raw.address.postcode
            this.address.city = item.raw.address.city
            this.address.state = item.raw.address.state
            this.address.lat = item.raw.lat
            this.address.long = item.raw.lon
            this.address.country = item.raw.address.country

            if (item.raw.address.neighbourhood) {
                this.address.neighborhood = item.raw.address.neighbourhood
            }
            else if (item.raw.address.suburb) {
                this.address.neighborhood = item.raw.address.suburb
            }
            else if (item.raw.address.city_district) {
                this.address.neighborhood = item.raw.address.city_district
            }

            this.$nextTick(() => this.$refs.number.$el.focus())
        },

        completeAddress() {
            this.$q.loading.show()
            let query = ''

            if (this.address.address) query += this.address.address
            if (this.address.city) query += `, ${this.address.city}`
            if (this.address.state) query += `, ${this.address.state}`

            provider.search({ query: query })
            .then((result) => {
                this.$q.loading.hide()

                if (result.length === 1) {
                    this.address.address = result[0].raw.address.road

                    this.address.postal_code = result[0].raw.address.postcode
                    this.address.city = result[0].raw.address.city
                    this.address.state = result[0].raw.address.state
                    this.address.lat = result[0].raw.lat
                    this.address.long = result[0].raw.lon
                    this.address.country = result[0].raw.address.country

                    if (result[0].raw.address.neighbourhood) {
                        this.address.neighborhood = result[0].raw.address.neighbourhood
                    }
                    else if (result[0].raw.address.suburb) {
                        this.address.neighborhood = result[0].raw.address.suburb
                    }
                    else if (result[0].raw.address.city_district) {
                        this.address.neighborhood = result[0].raw.address.city_district
                    }
                }
                else if (result.length > 1) {
                    this.selected_address = 1
                    this.address_list = []

                    result.forEach((address, index) => {
                        this.address_list.push({
                            label: address.label, value: index + 1, address: address
                        })
                    })

                    this.show_address_list = true
                }
                else {
                    this.$q.notify({
                        message: this.$t('no_address_found'),
                        type: 'negative',
                        icon: 'fal fa-ban'
                    })
                }
            })
        },

        selectAddress() {
            let index = this.selected_address - 1

            this.address.address = this.address_list[index].address.raw.address.road

            this.address.postal_code = this.address_list[index].address.raw.address.postcode
            this.address.city = this.address_list[index].address.raw.address.city
            this.address.state = this.address_list[index].address.raw.address.state
            this.address.lat = this.address_list[index].address.raw.lat
            this.address.long = this.address_list[index].address.raw.lon
            this.address.country = this.address_list[index].address.raw.address.country

            if (this.address_list[index].address.raw.address.neighbourhood) {
                this.address.neighborhood = this.address_list[index].address.raw.address.neighbourhood
            }
            else if (this.address_list[index].address.raw.address.suburb) {
                this.address.neighborhood = this.address_list[index].address.raw.address.suburb
            }
            else if (this.address_list[index].address.raw.address.city_district) {
                this.address.neighborhood = this.address_list[index].address.raw.address.city_district
            }

            this.show_address_list = false
        }
    },

    watch: {
        show_task: function() {
            if (this.show_task && this.task) {
                this.branch = this.task.branch
                this.task_data.branch_address = this.task.branch_address
                this.branch_company = this.task.branch_company
                this.branch_document = this.task.branch_document
                this.task_data.branch_lat = this.task.branch_lat
                this.task_data.branch_long = this.task.branch_long
                this.task_data.branch_name = this.task.branch_name ? this.task.branch_name : null
                this.task_data.collection = this.task.collection
                this.id = this.task.id ? this.task.id : 0
                this.status = this.task.status
                this.start_time = this.task.start_time
                this.end_time = this.task.end_time
                this.observation_request = this.task.observation_request

                if (this.task.start_time) {
                    let new_time = this.task.start_time.split(':')
                    let today = new Date()
                    this.start_time = date.adjustDate(today, { hours: new_time[0], minutes: new_time[1], seconds: new_time[2] })
                }

                if (this.task.end_time) {
                    let new_time = this.task.end_time.split(':')
                    let today = new Date()
                    this.end_time = date.adjustDate(today, { hours: new_time[0], minutes: new_time[1], seconds: new_time[2] })
                }
            }
        }
    },

    validations() {
        return {
            task_data: {
                branch_name: { required },
                branch_address: { required },
                collection: { required },
                branch_lat: { required },
                branch_long: { required },
            },
            address: {
                address: { required },
                city: { required },
                state: { required },
                lat: { required },
                long: { required },
            }
        }
    }
}
</script>

<style>

</style>
